export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/female_icon.04feaaef.svg","height":19,"width":15,"blurWidth":0,"blurHeight":0};